import React, { useState, useEffect } from 'react';
import { Nav, Spinner } from 'react-bootstrap';
import CommonConfigPage from './CommonConfigPage';
import AreaEditDialog from './Dialogs/AreaEditDialog';
import { useCommonConfigFunctions } from '../../hooks/useCommonConfigFunctions';
import DataTable from '../DataTable/datatable.component';

function AreasTable({ onRowClick, refresh }) {

    const [data, setData] = useState();
    const { getAllFunction: getAreas, loading } = useCommonConfigFunctions("areas");

    useEffect(() => {
        getAreas().then(areas => setData(areas));
    }, [refresh])

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'stringIncludes',
            Cell: (props) => {
                return <Nav><Nav.Link onClick={() => { onRowClick(props.row.original) }}>{props.value}</Nav.Link></Nav>
            }
        },
        {
            Header: 'AD Group Name',
            accessor: 'adGroupName',
            filter: 'stringIncludes'
        }
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    return data ? <DataTable id="Areas" tableColumns={tableColumns} tableData={data} /> : <p>No data</p>
}

function AreasConfiguration() {
    const getNewArea = () => {
        return { id: null, name: "", adGroupName: "" }
    };

    return (
        <CommonConfigPage
            title="Areas"
            table={(showEditDialog, refreshList) => <AreasTable onRowClick={showEditDialog} refresh={refreshList} />}
            dialog={(dialogData, setDialogData, showDialog, closeDialog) => <AreaEditDialog dialogData={dialogData} setDialogData={setDialogData} showDialog={showDialog} closeDialog={closeDialog} />}
            getNewConfigObject={getNewArea}
        />
    );
}

export default AreasConfiguration;